module.exports = __webpack_public_path__ + "img/huehuetoca.58c3da9f.jpg";